/**
 *   Generated file. Do not edit
 */

export const ResourceMetaData = {
  '/lte/enabled': {
    put: {
      minApiVersion: 2.13,
      configModeRequired: false,
      schema: {
        type: 'boolean',
      },
    },
  },

  '/lte/application-data': {
    put: {
      minApiVersion: 2.11,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/Bytes',
      },
    },
  },
};
